"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _material = require("@mui/material");

var _alert = _interopRequireDefault(require("../../shared/themes/assets/svg/alert.svg"));

var _templateObject, _templateObject2, _templateObject3;

var AlertSection = (0, _styledComponents.default)(_material.Paper)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\nbackground-color: rgba(250, 65, 65, 0.12);\nwidth: 100%;\nbox-shadow: none;\nfont-size: 12px;\ndisplay: flex;\nflex-direction: row;\njustify-content: flex-start;\nalign-items: center;\npadding: 6px 11px;\nmargin-bottom: 8px;\n"])));
var StyledImg = (0, _styledComponents.default)('img')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\nmargin-right: 15px;\n"])));
var InfosWrapper = (0, _styledComponents.default)('div')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\nmargin-bottom: 10px;\n"])));

var PaperHeader = function PaperHeader(_ref) {
  var alerts = _ref.alerts;
  return /*#__PURE__*/_react.default.createElement(InfosWrapper, null, alerts.map(function (alert) {
    return /*#__PURE__*/_react.default.createElement(AlertSection, {
      key: alert.TDL_LBL_TEXT
    }, /*#__PURE__*/_react.default.createElement(StyledImg, {
      src: _alert.default,
      alt: "_blank"
    }), alert.TDL_LBL_TEXT);
  }));
};

var _default = PaperHeader;
exports.default = _default;